import { render } from "./absen-input-custom.vue?vue&type=template&id=5905aa8d"
import script from "./absen-input-custom.vue?vue&type=script&lang=js"
export * from "./absen-input-custom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__